import './Windows.css';

import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { ResellerHeader } from './blocks/ResellerHeader';
import styles from './ResellerLayout.module.css';

export default function ResellerLayout() {
  return (
    <>
      <ResellerHeader />

      <div className={styles.resellerLayout}>
        <Suspense fallback={'...'}>
          <Outlet />
        </Suspense>
      </div>
    </>
  );
}
